module.exports = [{
      plugin: require('/home/kaustubhdamania/CodingStuff/Portfolio/MyPortfolio/node_modules/gatsby-plugin-transition-link/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/home/kaustubhdamania/CodingStuff/Portfolio/MyPortfolio/node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[],"maxWidth":800},
    },{
      plugin: require('/home/kaustubhdamania/CodingStuff/Portfolio/MyPortfolio/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
